import React, { useEffect, useMemo, useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { getImageUrl } from '../utils/helpers';

const ServicesCarousel = ({ images = [] }) => {
  const slides = useMemo(
    () => images.filter((item) => String(item?.UrlImagen || '').trim()).slice(0, 6),
    [images]
  );
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    setActiveIndex(0);
  }, [slides.length]);

  useEffect(() => {
    if (slides.length <= 1) return undefined;
    const timer = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % slides.length);
    }, 3800);
    return () => clearInterval(timer);
  }, [slides.length]);

  if (slides.length === 0) return null;

  const goTo = (index) => {
    setActiveIndex((index + slides.length) % slides.length);
  };

  return (
    <section className="mb-8" aria-label="Galeria de servicios">
      <div className="relative overflow-hidden rounded-lg border border-pink-100 bg-white shadow-lg">
        <div
          className="flex transition-transform duration-700 ease-out"
          style={{ transform: `translateX(-${activeIndex * 100}%)` }}
        >
          {slides.map((slide, index) => (
            <div key={slide.Id || `${slide.UrlImagen}-${index}`} className="relative min-w-full">
              <img
                src={getImageUrl(slide.UrlImagen)}
                alt={slide.Titulo || 'Servicio Mora.Artt'}
                className="h-56 w-full object-cover sm:h-72 md:h-80"
                loading={index === 0 ? 'eager' : 'lazy'}
                onError={(event) => {
                  event.currentTarget.onerror = null;
                  event.currentTarget.src = getImageUrl('');
                }}
              />
              {slide.Titulo && (
                <div className="absolute bottom-0 left-0 right-0 bg-white/85 px-4 py-3 backdrop-blur-sm">
                  <p className="truncate text-sm font-semibold text-purple-700 md:text-base">
                    {slide.Titulo}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>

        {slides.length > 1 && (
          <>
            <button
              type="button"
              onClick={() => goTo(activeIndex - 1)}
              className="absolute left-3 top-1/2 flex h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full bg-white/90 text-purple-700 shadow hover:bg-white"
              aria-label="Imagen anterior"
            >
              <ChevronLeft className="h-5 w-5" />
            </button>
            <button
              type="button"
              onClick={() => goTo(activeIndex + 1)}
              className="absolute right-3 top-1/2 flex h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full bg-white/90 text-purple-700 shadow hover:bg-white"
              aria-label="Imagen siguiente"
            >
              <ChevronRight className="h-5 w-5" />
            </button>

            <div className="absolute right-4 top-3 flex gap-2">
              {slides.map((slide, index) => (
                <button
                  key={slide.Id || index}
                  type="button"
                  onClick={() => goTo(index)}
                  className={`h-2.5 rounded-full transition-all ${index === activeIndex ? 'w-8 bg-pink-500' : 'w-2.5 bg-white/80'}`}
                  aria-label={`Ir a imagen ${index + 1}`}
                />
              ))}
            </div>
          </>
        )}
      </div>
    </section>
  );
};

export default ServicesCarousel;
